exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-19d53f72] .tips{font-size:13px;color:#999;margin-bottom:20px;margin-left:75px}.dialog-footer[data-v-19d53f72]{padding-top:20px;border-top:1px solid #e6ebf5;text-align:right}[data-v-19d53f72] .el-cascader{width:100%}\n", ""]);

// exports
